import Snackbar from './Snackbar.vue';
import Vue from 'vue';
import vuetify from './vuetify';

import i18n from '../i18n';

const v = new Vue({
    vuetify,
    i18n,
    render: h => h(Snackbar)
});
v.$mount();
document.body.appendChild(v.$el);

const snackbar = v.$children[0];

function info(mes, timeout, closeEvent) {
    snackbar.info(mes, timeout, closeEvent);
}

function error(mes, timeout, closeEvent) {
    snackbar.error(mes, timeout, closeEvent);
}

function warning(mes, timeout, closeEvent) {
    snackbar.warning(mes, timeout, closeEvent);
}

function success(mes, timeout, closeEvent) {
    snackbar.success(mes, timeout, closeEvent);
}

function handleError(error, timeout, closeEvent) {
    snackbar.error(error.msg, timeout, closeEvent);//页面显示error时只显示内容不显示文字
    // snackbar.error(error.code + ": " + error.msg, timeout);
}

export default {
    info,
    success,
    warning,
    error,
    handleError
}